import { ComponentWithAs, createIcon, IconProps } from '@chakra-ui/react'

export const HoldCallIcon: ComponentWithAs<'svg', IconProps> = createIcon({
    displayName: 'HoldCallIcon',
    viewBox: '0 0 16 18',
    path: (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8298 0.999997C11.5196 0.999997 11.2291 1.08406 10.9797 1.23064C10.7258 0.625229 10.1275 0.199997 9.42982 0.199997C8.73218 0.199997 8.13386 0.625229 7.87991 1.23064C7.63054 1.08406 7.34 0.999997 7.02982 0.999997C6.10198 0.999997 5.34982 1.75216 5.34982 2.68L5.34975 10.6H5.32588L3.36794 8.64206C2.71186 7.98598 1.64814 7.98598 0.99206 8.64206C0.335979 9.29814 0.33598 10.3619 0.992061 11.0179L4.79589 14.8218C4.95863 14.9845 5.14727 15.1073 5.34885 15.1895C6.45963 16.4001 8.05622 17.16 9.82975 17.16C12.9045 17.16 15.4455 14.878 15.8528 11.9151C15.8901 11.7758 15.9098 11.6299 15.9098 11.48V5.08C15.9098 4.15216 15.1577 3.4 14.2298 3.4C13.9722 3.4 13.728 3.458 13.5098 3.56167V2.68C13.5098 1.75216 12.7577 0.999997 11.8298 0.999997ZM8.70982 1.88C8.70982 1.48235 9.03217 1.16 9.42982 1.16C9.82746 1.16 10.1498 1.48235 10.1498 1.88L10.1496 7.88008C10.1496 8.14517 10.3645 8.36008 10.6296 8.36007C10.8947 8.36007 11.1096 8.14517 11.1096 7.88007L11.1096 2.69427C11.1097 2.68953 11.1098 2.68477 11.1098 2.68C11.1098 2.28235 11.4322 1.96 11.8298 1.96C12.2275 1.96 12.5498 2.28235 12.5498 2.68L12.5496 7.88008C12.5496 8.14517 12.7645 8.36007 13.0296 8.36007C13.2947 8.36007 13.5096 8.14517 13.5096 7.88008V5.09414C13.5097 5.08944 13.5098 5.08473 13.5098 5.08C13.5098 4.68235 13.8322 4.36 14.2298 4.36C14.6275 4.36 14.9498 4.68235 14.9498 5.08V11.48C14.9498 11.5512 14.9396 11.6192 14.9209 11.6831C14.914 11.7067 14.9089 11.7309 14.9057 11.7554C14.5754 14.2637 12.4283 16.2 9.82975 16.2C8.2985 16.2 6.9247 15.5284 5.98573 14.4621C5.92759 14.3961 5.85241 14.3473 5.76841 14.3211C5.66144 14.2877 5.56054 14.2288 5.47471 14.1429L1.67088 10.3391C1.38971 10.0579 1.38971 9.60206 1.67088 9.32088C1.95206 9.0397 2.40794 9.0397 2.68912 9.32088L4.78764 11.4194C4.87766 11.5094 4.99975 11.56 5.12706 11.56H5.82975C6.09484 11.56 6.30974 11.3451 6.30975 11.08L6.30982 2.68C6.30982 2.28235 6.63217 1.96 7.02982 1.96C7.42161 1.96 7.74031 2.27293 7.74961 2.66249L7.74961 7.88008C7.74961 8.14517 7.96452 8.36008 8.22961 8.36007C8.49471 8.36007 8.70961 8.14517 8.70961 7.88007L8.70961 2.69429C8.70975 2.68954 8.70982 2.68478 8.70982 2.68V1.88Z"
            fill="currentColor"
        />
    )
})

export const HoldOutlineIcon: ComponentWithAs<'svg', IconProps> = createIcon({
    displayName: 'HoldOutlineIcon',
    viewBox: '0 0 24 24',
    path: (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 4L21 2V17C21 18.6569 19.6569 20 18 20C16.3431 20 15 18.6569 15 17C15 15.3431 16.3431 14 18 14H20V6.15385L9 7.84615V19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16H8V4ZM9 4.85792L20 3.16561V5.14208L9 6.83439V4.85792ZM4 19C4 17.8954 4.89543 17 6 17H8V19C8 20.1046 7.10457 21 6 21C4.89543 21 4 20.1046 4 19ZM16 17C16 15.8954 16.8954 15 18 15H20V17C20 18.1046 19.1046 19 18 19C16.8954 19 16 18.1046 16 17Z"
            fill="currentColor"
        />
    )
})

export const HoldOffOutlineIcon: ComponentWithAs<'svg', IconProps> = createIcon({
    displayName: 'HoldOffOutlineIcon',
    viewBox: '0 0 25 24',
    path: (
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5 16V6.84013L9.5 8.57218V19C9.5 20.6569 8.15685 22 6.5 22C4.84315 22 3.5 20.6569 3.5 19C3.5 17.3431 4.84315 16 6.5 16H8.5ZM4.5 19C4.5 17.8954 5.39543 17 6.5 17H8.5V19C8.5 20.1046 7.60457 21 6.5 21C5.39543 21 4.5 20.1046 4.5 19Z"
                fill="currentColor"
            />
            <path
                d="M15.5002 16.9648L17.0311 19.6164C17.031 19.6163 17.0312 19.6164 17.0311 19.6164L18.0171 21.3238L18.8831 20.8238L8.44269 2.74048L7.57666 3.24048L15.5002 16.9648C15.5002 16.9647 15.5002 16.965 15.5002 16.9648Z"
                fill="currentColor"
            />
            <path
                d="M21.5 17C21.5 18.3176 20.6506 19.4368 19.4695 19.8399L18.9546 18.9481C19.8402 18.7423 20.5 17.9482 20.5 17V15H18.5C17.9243 15 17.4054 15.2433 17.0404 15.6326L16.5257 14.7411C17.0533 14.2796 17.744 14 18.5 14H20.5V6.15385L12.2965 7.41592L11.76 6.48669L20.5 5.14208V3.16561L10.712 4.67145L10.1755 3.74223L21.5 2V17Z"
                fill="currentColor"
            />
        </g>
    )
})

export const HoldOffIcon: ComponentWithAs<'svg', IconProps> = createIcon({
    displayName: 'HoldOffIcon',
    viewBox: '0 0 24 24',
    path: (
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.0839 19.1581C20.6488 18.6125 21 17.8473 21 17V2L10.6702 3.5892L12.883 7.24877L20 6.15385V14H18C17.6704 14 17.3533 14.0531 17.0566 14.1513L20.0839 19.1581ZM15.0083 17.2253L16.411 19.5451C15.6234 19.0523 15.081 18.2042 15.0083 17.2253ZM9.30851 7.79869L9 7.84615V19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16H8V5.63462L9.30851 7.79869Z"
                fill="currentColor"
            />
            <path d="M20.232 21.5L7.86603 1L7 1.5L19.366 22L20.232 21.5Z" fill="currentColor" />
        </g>
    )
})

export const HoldIcon: ComponentWithAs<'svg', IconProps> = createIcon({
    displayName: 'HoldIcon',
    viewBox: '0 0 24 24',
    path: (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 4L21 2V17C21 18.6569 19.6569 20 18 20C16.3431 20 15 18.6569 15 17C15 15.3431 16.3431 14 18 14H20V6.15385L9 7.84615V19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16H8V4Z"
            fill="currentColor"
        />
    )
})
